import type {Theme, Components} from "../..";

type OutlinedInputOverrides = Components<Theme>["MuiOutlinedInput"];

const overrides: OutlinedInputOverrides = {
    defaultProps: {},
    styleOverrides: {
        root: ({theme}) => ({
            ...theme.typography.title4,
            color: theme.color.text.default,
            fontWeight: theme.typography.fontWeight.medium,

            "&:not(.Mui-focused):hover .MuiOutlinedInput-notchedOutline": {
                borderWidth: 1.5,
            },

            "&:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled):hover .MuiOutlinedInput-notchedOutline":
                {
                    borderColor: theme.color.border.default,
                },

            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.color.border.interactive,
                borderWidth: 2,
            },

            "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.color.border.disabled,
            },

            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: theme.color.border.critical,

                "&:hover": {
                    borderColor: theme.color.border.critical,
                },
            },
        }),
        input: {
            padding: 12,
        },
        notchedOutline: ({theme}) => ({
            borderColor: theme.color.border.subtle,
        }),
    },
};

export default overrides;
